import { registerBlockType } from "@wordpress/blocks";
import metadata from "./block.json";
import Save from "./save";
import Edit from "./Edit";
import "./style.scss";

registerBlockType(metadata.name, {
  edit: Edit,
  save: Save,
  icon: {
    foreground: "#0061FE",
    src: (
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18 3.69995H6C4.5 3.69995 3.2 4.99995 3.2 6.49995V18.5C3.2 20 4.4 21.2999 6 21.2999H18C19.5 21.2999 20.8 20.1 20.8 18.5V6.49995C20.8 4.99995 19.5 3.69995 18 3.69995ZM4.8 6.49995C4.8 5.79995 5.4 5.29995 6 5.29995H11.2V9.09995H4.8V6.49995ZM6 19.7C5.3 19.7 4.8 19.1 4.8 18.5V10.6H11.3V19.7H6ZM19.2 18.5C19.2 19.2 18.6 19.7 18 19.7H12.8V5.29995H18C18.7 5.29995 19.2 5.89995 19.2 6.49995V18.5Z"
        />
      </svg>
    ),
  },
});
